import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  children: ReactNode;
  variant?: "default" | "logout";
};

export function MailHeaderIconButton({
  label,
  children,
  variant = "default",
  className,
  ...props
}: Props) {
  return (
    <button
      type="button"
      aria-label={label}
      className={cn(
        "mail-header-icon-btn",
        variant === "logout" && "mail-header-icon-btn--logout",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
